import { create } from "zustand";
import { devtools } from "zustand/middleware";

const initialUser = {
  isAuthenticated: undefined,
  role: "",
  profile: { groups: {} },
  userRoles: {},
  disableLoginFlow: false,
};

// Selector functions
// Usage: useUserStore(selectUserDetails)
export const selectUserDetails = (state) => state.user;
export const selectUserId = (state) => state.user?.profile?.uid;

const useUserStore = create(
  devtools(
    (set) => ({
      user: { ...initialUser },

      // Mirrors UPDATE_ADMIN dispatch
      setAdmin: (profile, userRoles) =>
        set({
          user: {
            isAuthenticated: true,
            role: "admin",
            profile,
            userRoles,
            disableLoginFlow: false,
          },
        }),

      // Mirrors SET_SUPERADMIN dispatch (merges into user)
      setSuperadminUser: (payload) =>
        set((state) => ({ user: { ...state.user, ...payload } })),

      // Mirrors LOADING_USER dispatch
      setLoading: () =>
        set({
          user: {
            isAuthenticated: undefined,
            role: "",
            profile: { groups: {} },
            userRoles: {},
            disableLoginFlow: false,
          },
        }),

      // Mirrors UNAUTHORIZED_USER dispatch
      setUnauthorized: () =>
        set((state) => ({
          user: { ...state.user, isAuthenticated: "unauthorized" },
        })),

      // Mirrors DISABLE_LOGIN_FLOW dispatch
      setDisableLoginFlow: () =>
        set((state) => ({
          user: { ...state.user, disableLoginFlow: true },
        })),

      // Mirrors LOGOUT_USER dispatch
      logout: () =>
        set({ user: { isAuthenticated: false, role: "" } }),

      reset: () => set({ user: { ...initialUser } }),
    }),
    { name: "User" }
  )
);

export default useUserStore;
